import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'student-half-round-view',
})

export default class StudentHalfRoundViewComponent extends Vue {


    // -----------------------------------------------------
    // Properties

    @Prop({default: {}})
    public studentData!: any;

    @Prop()
    public isShowCaseView!: boolean;

    @Prop()
    public isStrugglingStudentView!: boolean;

    public get studentDatas() {
      return [
        {
          name: 'Knowledge',
          icon: 'emoji_objects',
          key: 'knowledge-data',
        },
        {
          name: 'Bio Graphical',
          icon: 'document_scanner',
          key: 'bio-data',
        },
        {
          name: 'Mindsets',
          icon: 'psychology',
          key: 'mindset',
        },
        {
          name: 'Context',
          icon: 'ability',
          key: 'context',
        },
        {
          name: 'Citizenship',
          icon: 'language',
          key: 'citizenship',
        },
      ];
    }
    public get studentInfo() {
      return {
        name: 'Profile',
        icon: 'student-profile',
        thumbnailUrl: this.studentData.avatorUrl,
      };
    }

    public onShowFacets() {
        let pathUrl = `/learners/${this.studentData.userId}?filter=true`;
        if (this.isShowCaseView) {
            pathUrl += '&isShowCaseView=true';
        }
        this.$router.push(pathUrl);
    }


    // -----------------------------------------------------
    // Methods


}
